import { prop } from 'ramda'

export const playtime = prop('playtime')
export const duration = prop('duration')
export const livesync = prop('livesync')
